import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import EditorActions from './EditorActions';

export type EditorActionsContainerProps = {};

type EditorAction = 'none' | 'randomize' | 'browseGenerators' | 'quickPalettes';

export function EditorActionsContainer(_props: EditorActionsContainerProps) {
  const dispatch = useDispatch();
  const focusMode = useSelector(selectors.base.$focusMode);
  const allGenerators = useSelector(selectors.gallery.$generators);
  const palettes = useSelector(selectors.base.$palettes);
  const editMode = useSelector(selectors.base.$editMode);

  let ctaAction: EditorAction = 'none';

  if (focusMode === 'existing' && editMode === 'object') {
    ctaAction = 'randomize';
  } else if (focusMode === 'existing' && editMode === 'material') {
    ctaAction = 'quickPalettes';
  } else if (focusMode === 'spawn') {
    ctaAction = 'browseGenerators';
  }

  const callbacks = useMemo(
    () => ({
      onAction: (action: Action) => {
        dispatch(action);
      },
    }),
    []
  );

  return <EditorActions palettes={palettes} ctaAction={ctaAction} callbacks={callbacks} />;
}
